import { render } from "./AccountTabBar.vue?vue&type=template&id=421926d6"
import script from "./AccountTabBar.vue?vue&type=script&lang=js"
export * from "./AccountTabBar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__